
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nos-dossiers/faq",
      function () {
        return require("private-next-pages/nos-dossiers/faq/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nos-dossiers/faq"])
      });
    }
  